import React from 'react';

import {
	CommentsConfig,
	CommentsContext,
} from '../../../xlink/configs/CommentsConfig';
import {
	DefaultFiltersConfig,
	FiltersContext,
	IdelinkFiltersConfig,
} from '../../../xlink/configs/IdelinkFilters';
import {
	IdelinkRteConfig,
	RTEProvider,
} from '../../../xlink/configs/IdelinkRteConfig';
import { IdeLinkThemeContext } from '../../../xlink/configs/IdeLinkTheme';
import { UsersConfig } from '../../../xlink/configs/UsersConfig';
import {
	AreasConfig,
	AreasContext,
} from '../../../xlink/modules/Areas/Config/AreasConfig';
import { AuditsContext } from '../../../xlink/modules/Audits/Configs/AuditsConfig';
import {
	EventsConfig,
	EventsContext,
} from '../../../xlink/modules/Events/Config/EventsConfig';
import {
	DefaultSectorsConfig,
	HierarchyGroupsConfig,
	SectorsContext,
} from '../../../xlink/modules/HierarchyGroups/Config/SectorsConfig';
import {
	DefaultOffersConfig,
	OffersConfig,
	OffersContext,
} from '../../../xlink/modules/Offers/Configs/OffersConfig';
import {
	DefaultShopsConfig,
	ShopsConfig,
	ShopsContext,
} from '../../../xlink/modules/Shops/Config/ShopsConfig';
import { OxylinkConstants } from '../OxylinkConstants';
import { OxylinkAppTheme } from './OxylinkAppTheme';

export class OxylinkConfigs {
	public static Offers: OffersConfig = {
		...DefaultOffersConfig,
		showCreateTunable: false,
		showSyncPackagedOrders: false,
	};

	public static Areas: AreasConfig = {
		...DefaultSectorsConfig,
		hideParent: true,
		parentModelCode: OxylinkConstants.MODEL_CODE_COUNTRY,
		modelCode: OxylinkConstants.MODEL_CODE_AREAS,
	};

	public static Sectors: HierarchyGroupsConfig = {
		...DefaultSectorsConfig,
		hideParent: false,
		parentModelCode: OxylinkConstants.MODEL_CODE_AREAS,
		modelCode: OxylinkConstants.MODEL_CODE_GROUP,
	};

	public static Shops: ShopsConfig = {
		...DefaultShopsConfig,
		useCustomAudienceDefinition: true,
		shopParentModelCode: OxylinkConstants.MODEL_CODE_GROUP,
	};

	public static Users: UsersConfig = {
		showResetPasswordButton: false,
		showInviteButton: false,
		showAutoInviteDialog: false,
	};

	public static Events: EventsConfig = { showCreateReminders: true };
	public static Comments: CommentsConfig = { videosEnabled: true };

	public static Filters: IdelinkFiltersConfig = {
		...DefaultFiltersConfig,
		filtersName: OxylinkConstants.OXYLINK_FILTERS_STORAGE_KEY,
		enabled: false,
	};
}

export const OxylinkContextWrapper = ({ children }: React.PropsWithChildren<any>) => (
	<IdeLinkThemeContext.Provider value={OxylinkAppTheme}>
		<CommentsContext.Provider value={OxylinkConfigs.Comments}>
			<AreasContext.Provider value={OxylinkConfigs.Areas}>
				<SectorsContext.Provider value={OxylinkConfigs.Sectors}>
					<EventsContext.Provider value={OxylinkConfigs.Events}>
						<OffersContext.Provider value={OxylinkConfigs.Offers}>
							<ShopsContext.Provider value={OxylinkConfigs.Shops}>
								<FiltersContext.Provider value={OxylinkConfigs.Filters}>
									<AuditsContext.Provider
										value={{
											autoChecksEnabled: true,
											auditAnalysisEnabled: true,
										}}
									>
										<RTEProvider value={IdelinkRteConfig}>
											{children}
										</RTEProvider>
									</AuditsContext.Provider>
								</FiltersContext.Provider>
							</ShopsContext.Provider>
						</OffersContext.Provider>
					</EventsContext.Provider>
				</SectorsContext.Provider>
			</AreasContext.Provider>
		</CommentsContext.Provider>
	</IdeLinkThemeContext.Provider>
);
